import React from "react";
import AppAppBar from "../modules/views/AppAppBar";
import AppFooter from "../modules/views/AppFooter";
import AppForm from "../modules/views/AppForm";
import Typography from "../modules/components/Typography";
import { Link } from "@mui/material";
import { Field, Form, FormSpy } from 'react-final-form';
import { Box } from "@mui/material";
import RFTextField from "../modules/form/RFTextField";
import FormFeedback from "../modules/form/FormFeedback";
import FormButton from "../modules/form/FormButton";
import { useLocation, useNavigate } from 'react-router-dom';
import { verification, required } from '../modules/form/validation';
import { userConfirmSignUp, userResendVerificationCode, userSignIn } from "../modules/components/authentication";
import { FORM_ERROR } from 'final-form';
import { registerUser } from '../modules/components/api';
import logger from "../modules/components/logger";

export default function Verification() {
  const navigate = useNavigate();

  const [codeResentMessage, setCodeResentMessage] = React.useState("");

  const {state} = useLocation();
  const userEmail = state?.userEmail;
  const userPassword = state?.userPassword;

  React.useEffect(() => {
    if (!userEmail)
      navigate('/');
  }, [navigate, userEmail]);

  const [isValid, setIsValid] = React.useState(false);

  const validate = (values) => {
    const errors = required(['verification'], values);

    if (!errors.verification) {
      const verificationError = verification(values.verification);
      if (verificationError) {
        errors.verification = verificationError;
      }
    }

    setIsValid(Object.keys(errors).length === 0);

    return errors;
  };

  const handleSubmit = ({ verification }) => {
    return userConfirmSignUp(userEmail, verification)
      .then((value) => {
        if (value === "SUCCESS") {}
          return userSignIn(userEmail, userPassword)
            .then((res) => {
              registerUser(res.username, userEmail);
              setTimeout(() => navigate('/dashboard'), 250);
            });
      }).catch((reason) => {
        const exception = reason.code;
        logger.error(exception);
        let message = "Could not verify.";
        if (exception === "CodeMismatchException")
          message = "Code was incorrect.";
        return {[FORM_ERROR]: message};
      });
  };

  const handleClickResend = () => {
    setCodeResentMessage("");
    return userResendVerificationCode(userEmail)
      .then(() => {
        setCodeResentMessage("(code successfully resent)");
      })
      .catch((reason) => {
        logger.error(reason);
        if (reason.code === "LimitExceededException")
          setCodeResentMessage("(too many resends, try again later)");
        else
          setCodeResentMessage("(failed to resend)")
      });
  }

  return (
    <React.Fragment>
      <AppAppBar />
      <AppForm>
        <React.Fragment>
          <Typography variant="h3" gutterBottom marked="center" align="center">
            Email Verification
          </Typography>
          <Typography variant="body2" align="center">
            We sent a code to {userEmail}.
          </Typography>
        </React.Fragment>
        <Form
          onSubmit={handleSubmit}
          subscription={{ submitting: true }}
          validate={validate}
        >
          {({ handleSubmit: handleSubmit2, submitting }) => (
            <Box component="form" onSubmit={handleSubmit2} noValidate sx={{ mt: 6 }}>
              <Field
                fullWidth
                autoFocus
                size="large"
                component={RFTextField}
                disabled={submitting}
                required
                name="verification"
                autoComplete="verification"
                label="Verification Code"
                inputMode="numeric"
                type="number"
                margin="normal"
              />
              <FormSpy subscription={{ submitError: true }}>
                {({ submitError }) =>
                  submitError ? (
                    <FormFeedback error sx={{ mt: 2 }}>
                      {submitError}
                    </FormFeedback>
                  ) : null
                }
              </FormSpy>
              <FormButton
                sx={{ mt: 3, mb: 2 }}
                disabled={!isValid || submitting}
                size="large"
                color="secondary"
                fullWidth
              >
                {submitting ? 'In progress…' : 'Submit'}
              </FormButton>
            </Box>
          )}
        </Form>
        <React.Fragment>
          <Typography variant="body2" align="center">
            {"Can't find it? Check your spam folder, or "}
            <Link 
              component="button"
              underline="always" 
              onClick={handleClickResend}
              variant="body2"
              style={{paddingBottom: "2px"}}
            >
              click here to resend it.
            </Link>
            <br />
            {codeResentMessage}
          </Typography>
        </React.Fragment>
      </AppForm>
      <AppFooter />
    </React.Fragment>
  );
}